module.exports = __webpack_public_path__ + "img/home_img_wzss.226fc731.png";